import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon, Checkbox} from 'semantic-ui-react';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {CAROUSEL_ITEM, items, RETURN_TIME} from '../../../common/dictionaries/dashboard';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Dashboard from '../../../picking/components/dashboard';
import CpdKpi from '../../../kpis/components/cpd/kpiData';
import './slideshow.scss';

let timer = null;
let timerForNextShift = null;

class PickingSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeItemIndex': 0,
      'autoPlay': false,
    };
    this.setShorterMissingTime = this.setShorterMissingTime.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingDashboard,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchSystemParameter('INTERVAL_CHANGE_PICKING_SLIDE');
    this.checkIfAutoPlay();
  }

  componentWillUnmount() {
    this.stopTimer();
    this.stopTimerForNextShift();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  nextSlide() {
    const {activeItemIndex} = this.state;
    const lastItem = items.length - 1;
    const nextSlide = activeItemIndex >= lastItem ? 0 : activeItemIndex + 1;
    this.setState({'activeItemIndex': nextSlide});
  }

  startTimer() {
    const {systemParameters} = this.props;
    const intervalToChangeSlide =
      getSystemParameterValue(
        systemParameters,
        'INTERVAL_CHANGE_PICKING_SLIDE'
      ) || 60;

    timer = setInterval(() => {
      this.nextSlide();
    }, intervalToChangeSlide * 1000);
  }

  checkIfAutoPlay() {
    const {autoPlay} = this.state;
    if (!autoPlay) {
      this.stopTimer();
      return null;
    }
    this.startTimer();
  }

  stopTimerForNextShift() {
    if (timerForNextShift) {
      clearInterval(timerForNextShift);
    }
  }

  changeActiveItem(activeItemIndex) {
    const {autoPlay} = this.state;
    if (!autoPlay) {
      this.setState({activeItemIndex});
      return;
    }
    this.setState({activeItemIndex}, () => {
      this.stopTimer();
      this.startTimer();
    });
  }

  startTimerForNextShift(timeInSeconds) {
    const {autoPlay, activeItemIndex} = this.state;
    let counter = 0;
    timerForNextShift = setInterval(() => {
      counter++;
      if (timeInSeconds - counter > RETURN_TIME) {
        return;
      }
      if (autoPlay) {
        this.setState({'autoPlay': false}, () => this.checkIfAutoPlay());
      }
      if (activeItemIndex === CAROUSEL_ITEM.CPD_KPI) {
        this.changeActiveItem(CAROUSEL_ITEM.DASHBOARD);
      }
    }, 1000);
  }

  autoPlayChange(event, value) {
    this.setState({'autoPlay': !value.checked}, () => this.checkIfAutoPlay());
  }

  setShorterMissingTime(timeInSeconds) {
    if (timeInSeconds <= 0) {
      return;
    }
    this.startTimerForNextShift(timeInSeconds);
  }

  renderContent() {
    const {activeItemIndex} = this.state;
    switch (activeItemIndex) {
      default:
      case CAROUSEL_ITEM.DASHBOARD:
        return <Dashboard onShorterMissingTime={this.setShorterMissingTime} />;
      case CAROUSEL_ITEM.CPD_KPI:
        return <CpdKpi seePriceSection={true} />;
    }
  }

  renderControlerItem() {
    const {activeItemIndex} = this.state;
    return items.map((element, key) => {
      const position = element.index;
      return (
        <li
          key={position}
          onClick={this.changeActiveItem.bind(this, position)}
          className={activeItemIndex === position ? 'active' : ''}
        >
          <Icon
            name='circle'
            size='small'
            color={activeItemIndex === position ? 'red' : 'black'}
          />
        </li>
      );
    });
  }

  renderControlersSection() {
    const {autoPlay} = this.state;
    return (
      <div className='footer-section'>
        <ul className='slides-container'>{this.renderControlerItem()}</ul>
        <div className='auto-play-container'>
          <div className='label'>Fijar</div>
          <Checkbox
            toggle
            defaultChecked={!autoPlay}
            onChange={this.autoPlayChange.bind(this)}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderContent()}
        {this.renderControlersSection()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'systemParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchSystemParameter, navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchSystemParameter,
  navigateTo,
})(PickingSlideShow);
